//Please add the language resource
const logLoginDetail = {
  operation:'操作描述',
  platform:'操作平台',
  useTime:"耗时",
  ip:"ip",
  userNo:"用户",
  userName:"用户名称",
  createTime:"操作时间",
  msg:{
  }
};
export default logLoginDetail



// WEBPACK FOOTER //
// ./src/page/int/logLoginDetail/lang/logLoginDetail.en.js